<script>
export default {
  name: 'QuickviewModal',
  props: {
    product: {
      type: Object,
      default: {}
    }
  },
  data()
  {
      return {
          quantity: 1
      };
  },
  methods: 
  {
      plus()
      {
        if(this.quantity < parseInt(this.product.stock_on_hand))
          this.quantity += 1;
      },
      minus()
      {

          this.quantity = (this.quantity > 1 ? this.quantity-=1 : 1);
      },
      addToCart()
      {

        this.$emit('onClose');
          this.$emit('addToCart', {
              product: this.product,
              quantity: this.quantity
          });
          this.quantity = 1;
      },
      addToWishlist()
      {
          this.$emit('addToWishlist', {
              product: this.product,
              quantity: 1
          });
      },
    closeModal () {
    }
  },
  created () {
    console.log(this.product)
  }
}
</script>
<template>
    <!-- MODAL AREA START (Quick View Modal) -->
    <div>
    <div class="ltn__modal-area ltn__quick-view-modal-area">
        <div class="modal fade show" id="quick_view_modal" tabindex="-1" style="display:block;">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            <!-- <i class="fas fa-times"></i> -->
                        </button>
                    </div>
                    <div class="modal-body">
                         <div class="ltn__quick-view-modal-inner">
                             <div class="modal-product-item">
                                <div class="row">
                                    <div class="col-lg-6 col-12">
                                        <div class="modal-product-img">
                                            <img :src="product.product_image[0]" alt="#">
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-12">
                                        <div class="modal-product-info">
                                            <!-- <div class="product-ratting">
                                                <ul>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star"></i></a></li>
                                                    <li><a href="#"><i class="fas fa-star-half-alt"></i></a></li>
                                                    <li><a href="#"><i class="far fa-star"></i></a></li>
                                                    <li class="review-total"> <a href="#"> ( 95 Reviews )</a></li>
                                                </ul>
                                            </div> -->
                                            <h3>{{ product.product_name }}</h3>
                                            <div class="product-price">
                                                 <span>{{ (product.sale_type == 'fixed' || product.sale_type == 'percentage' ? product.sale_price : product.product_price) | currencyFormat }}</span>
                                                  <del v-if="product.sale_type == 'fixed' || product.sale_type == 'percentage'">{{ product.original_price | currencyFormat }}</del>
                                            </div>
                                            <div class="modal-product-meta ltn__product-details-menu-1">
                                                <!-- <ul>
                                                    <li>
                                                        <strong>Category:</strong>
                                                        <span>
                                                            <a href="#">{{ product.main_category_name }}</a>
                                                        </span>
                                                    </li>
                                                </ul> -->
                                                <small>({{ product.stock_on_hand }} Available)</small>
                                            </div>
                                            <div class="ltn__product-details-menu-2">
                                                <ul>
                                                    <li>
                                                        <div class="cart-plus-minus">
                                                            <div class="dec qtybutton" @click="minus">-</div>
                                                            <input type="text" v-model="quantity" value="1" name="qtybutton" readonly class="cart-plus-minus-box">
                                                            <div class="inc qtybutton" @click="plus">+</div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <button class="theme-btn-1 btn btn-effect-1" title="Add to Cart" @click="addToCart">
                                                            <i class="fas fa-shopping-cart"></i>
                                                            <span>ADD TO CART</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="ltn__product-details-menu-3">
                                                <!-- <ul>
                                                    <li>
                                                        <a @click="addToWishlist" class="" title="Wishlist">
                                                            <i class="far fa-heart"></i>
                                                            <span>Add to Wishlist</span>
                                                        </a>
                                                    </li>
                                                </ul> -->
                                            </div>
                                            <hr>
                                            <div class="ltn__social-media">
                                                <ul>
                                                    <li>Share:</li>
                                                    <li><a href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                                                    <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                                                    <li><a href="#" title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
                                                    <li><a href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    </div>
    <!-- MODAL AREA END -->
</template>



// WEBPACK FOOTER //
// src/components/shared/QuickviewModal.vue